export default __webpack_public_path__ + "static/media/main.c95c9f6d.png";